import * as React from "react";

import { UitkHeading, UitkText } from "uitk-react-text";

import { WizardRegionHotwireHeadingProps } from "components/flexComponents/WizardPWARegions/WizardRegionHotwire/typings";

export const MobileHeading = ({ title, innerTitle }: WizardRegionHotwireHeadingProps) => (
  <UitkHeading tag="h1" size={5}>
    {title && <UitkText>{title}</UitkText>}
    {innerTitle && <UitkText size={700}>{innerTitle}</UitkText>}
  </UitkHeading>
);
